export const FETCH_ALERT_POLICIES = "FETCH_ALERT_POLICIES";
export const CREATE_ALERT_POLICY = "CREATE_ALERT_POLICY";
export const ASSIGN_ALERT_POLICY_TO_GROUP = "ASSIGN_ALERT_POLICY_TO_GROUP";